import * as React from "react";
import CurrencyService from '../../../services/utils/CurrencyService';
import {withTranslation} from '../../../i18n';

const namespacesRequired = ['pot', 'common'];

const Amount = ({amount, hideEuroSign = false, customClass, ...props}) => {
  return (
      <span className={customClass || ''}>{typeof amount == "undefined" || amount == null
          ? 'A participé'
          : `${CurrencyService.centsToEuro(amount) + (hideEuroSign ? '' : ' €')}`}
        {props.children ? props.children : ''}
  </span>);
};

export default withTranslation(namespacesRequired)(Amount);
